/* eslint no-console: ["error", { allow: ["warn", "error"] }] */
import ApiService from '@services/apiService';
import { getCookie } from '@utils/cookie';

import {
  APP_LOAD,
  CHECK_AUTHENTICATION,
  CHECK_AUTHENTICATION_SUCCESS,
  CHECK_AUTHENTICATION_ERROR,
  CHECK_AUTHENTICATION_EXPIRY,
  HEARTBEAT_REFRESH,
  LOGOUT,
} from '../../constants/ActionTypes';

const CLOSE_TO_AUTH_EXPIRY_THRESHOLD_MINUTES = 30;

const initialState = {
  errors: null,
  inProgress: false,
  authChecked: false,
  isAuthenticated: null,
  isLoadingAuth: false,
  isAuthExpiryCookiePresent: false,
  isAuthCloseToExpiry: false,
  minutesLeftToAuthExpiry: null,
  token: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case APP_LOAD:
      return {
        ...state,
        token: action.token || null,
      };
    case CHECK_AUTHENTICATION:
      return {
        ...state,
        authChecked: true,
        isLoadingAuth: true,
      };
    case CHECK_AUTHENTICATION_SUCCESS:
      return {
        ...state,
        isAuthenticated: action.payload,
        isLoadingAuth: false,
      };
    case CHECK_AUTHENTICATION_ERROR:
      return {
        ...state,
        isAuthenticated: false,
        isLoadingAuth: false,
      };
    case CHECK_AUTHENTICATION_EXPIRY:
      return {
        ...state,
        isAuthExpiryCookiePresent: action.payload.isAuthExpiryCookiePresent,
        isAuthCloseToExpiry: action.payload.isAuthCloseToExpiry,
        minutesLeftToAuthExpiry: action.payload.minutesLeftToAuthExpiry,
      };
    case HEARTBEAT_REFRESH:
      return {
        ...state,
      };
    case LOGOUT:
      return {
        ...state,
        token: null,
        clareityUrl: action.payload,
      };
    default:
      return state;
  }
};

const checkAuthStatus = () => async dispatch => {
  dispatch({ type: CHECK_AUTHENTICATION });
  try {
    const authStatus = await ApiService.Auth.Status();
    return dispatch({ type: CHECK_AUTHENTICATION_SUCCESS, payload: authStatus });
  } catch (err) {
    console.error('Error: Authentication checkAuthStatus', err);
    return dispatch({ type: CHECK_AUTHENTICATION_ERROR });
  }
};

const checkAuthExpiry = () => async dispatch => {
  const authExpiryCookie = getCookie('AuthExpiry');
  if (!authExpiryCookie) {
    return dispatch({
      type: CHECK_AUTHENTICATION_EXPIRY,
      payload: {
        isAuthExpiryCookiePresent: false,
        isAuthCloseToExpiry: false,
        minutesLeftToAuthExpiry: null,
      },
    });
  }
  const authExpiryDate = new Date(authExpiryCookie);
  const minutesLeft = Math.floor((authExpiryDate - Date.now()) / 1000 / 60);
  return dispatch({
    type: CHECK_AUTHENTICATION_EXPIRY,
    payload: {
      isAuthExpiryCookiePresent: true,
      isAuthCloseToExpiry: minutesLeft < CLOSE_TO_AUTH_EXPIRY_THRESHOLD_MINUTES,
      minutesLeftToAuthExpiry: minutesLeft < 0 ? -1 : minutesLeft,
    },
  });
};

const heartBeat = () => async dispatch => {
  try {
    await ApiService.Auth.Heartbeat();
    return dispatch({ type: HEARTBEAT_REFRESH });
  } catch (err) {
    console.error('Error: Authentication heartBeat', err);
    return null;
  }
};

export {
  checkAuthStatus,
  checkAuthExpiry,
  heartBeat,
};
